/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.3.3",
    versionName: "0.2.0-nightly.2026.3.3",
    versionChannel: "nightly",
    buildDate: "2026-03-03T00:12:57.283Z",
    commitHash: "3f0a915501efe29fe28f7d7d3d958b6ec7d91388",
};
